import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button } from "primereact/button";
import { useHistory, useLocation } from "react-router-dom";
import { handleGetRequest } from "../../services/GetTemplate";
import styles from "./invoiceDetail.module.scss";
import { Tooltip } from "react-tippy";
import { handlePutRequest } from "../../services/PutTemplate";
import { toast } from "react-toastify";
import Water from "../common/WaterMark";
import generatePDF from "react-to-pdf";
import { Dialog } from "primereact/dialog";
import { Sidebar } from "primereact/sidebar";
import PaymentModel from "./PaymentModel";
import SoftStops from "../../modals/SoftStops";
import useViewOnly from "../../hooks/useViewOnly";
import CreateAdditionalInvoiceDialog from "./CreateAdditionalInvoiceDialog";
import GrantCreditDialog from "../../components/payment/GrantCreditDialog";
import { formatMoney } from "../../services/clientPaymentService";
import { InputTextarea } from "primereact/inputtextarea";
import { voidPurchaseInvoice } from "../../services/purchaseInvoiceService";
import PurchaseInvoiceDialog from "./PurchaseInvoiceDialog";
import { useDispatch } from "react-redux";

function Invoice() {
    const role = localStorage.getItem("role");
    const isClerk = role === "clerk";
    const viewOnly = useViewOnly();
    const dispatch = useDispatch();
    const targetRef = useRef();
    const history = useHistory();
    const [brands, setBrands] = useState();
    const [packages, setPackages] = useState([]);
    const [oversize, setOversize] = useState(0);
    const [dangerous, setDangerous] = useState(0);
    const [custom, setCustom] = useState(0);
    const [total, setTotal] = useState(0);
    const [loyalty, setLoyalty] = useState(0);
    const [pickup, setPickup] = useState(0);
    const [packaging, setPackaging] = useState(0);
    const [declaration, setDeclaration] = useState(0);
    const [fullTotal, setFullTotal] = useState(0);
    const [paid, setPaid] = useState(false);
    const [show, setShow] = useState(true);
    const [notpaid, setNotPaid] = useState(false);
    const [notes, setNotes] = useState();
    const [SubTotal, setSubTotal] = useState(0);
    const [discountedAmount, setDiscountedAmount] = useState(0);
    const [monthly, setMonthly] = useState(0);
    const [website, setWebsite] = useState(0);
    const [delivery, setDelivery] = useState(0);
    const [price, setPrice] = useState(0);
    const [handling, setHandling] = useState(0);
    const [insurance, setInsurance] = useState(0);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id");
    const [mobileEditOpen, setMobileEditOpen] = useState(false);
    const getBrands = async () => {
        const res = await handleGetRequest("/specificInvoice/" + id);
        setBrands(res?.data);
        setPackages(res?.data?.packages);
        setOversize(Math.round(res?.data?.oversizeFee * 100) / 100);
        setDangerous(res?.data?.dangerousItemFee ? Math.round(res?.data?.dangerousItemFee * 100) / 100 : 0);
        setCustom(Math.round(res?.data?.customDuties * 100) / 100);
        setTotal(Math.round(res?.data?.invoiceAmount * 100) / 100);
        setFullTotal(Math.round(res?.data?.invoiceAmount * 100) / 100);
        setLoyalty(Math.round(res?.data?.loyaltyDiscount * 100) / 100);
        setPickup(Math.round(res?.data?.pickupFee * 100) / 100);
        setPackaging(Math.round(res?.data?.packagingFee * 100) / 100);
        setDeclaration(Math.round(res?.data?.declarationFee * 100) / 100);
        setNotes(res?.data?.notes);
        setSubTotal(Math.round(res?.data?.TotalAmount * 100) / 100);
        setDiscountedAmount(Math.round(res?.data?.discountedAmount * 100) / 100);
        setMonthly(res?.data?.MonthlyFee);
        setWebsite(res?.data?.WebsiteFee);
        setDelivery(Math.round(res?.data?.deliveryFee * 100) / 100);
        setHandling(res?.data?.handling ? Math.round(res?.data?.handling * 100) / 100 : 0);
        setInsurance(res?.data?.insurance ? Math.round(res?.data?.insurance * 100) / 100 : 0);
        setPrice(res?.data?.itemsPrice);
        if (res?.data?.paymentStatus === "paid") {
            setPaid(true);
            setShow(false);
        }
    };
    useMemo(() => {
        getBrands();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const handlePackages = (name, value, index) => {
        const pack = packages;
        let val = parseFloat(value);
        pack[index][name] = val;
        pack[index].total = pack[index].price * pack[index].weight;
        setPackages(pack);
        const total = pack.reduce((a, b) => a + b.total, 0) + oversize + dangerous + custom + pickup + packaging + declaration + delivery + price + handling + insurance;
        let final = Math.round(total * 100) / 100;
        setTotal(final);
    };

    const handleoverSize = (e) => {
        setOversize(parseFloat(e));
        const total = packages.reduce((a, b) => a + b.total, 0) + parseFloat(e) + dangerous + custom + pickup + packaging + declaration + delivery + price + handling + insurance;
        if (brands?.customerType === "partner" || brands?.customerType === "admin") {
            const subTotal = packages.reduce((a, b) => a + b.total, 0) + parseFloat(e) + dangerous + custom + pickup + packaging + declaration + delivery + price + handling + insurance;
            const total = subTotal - discountedAmount;
            let final = Math.round(total * 100) / 100;
            let final1 = Math.round(subTotal * 100) / 100;
            setSubTotal(final1);
            setTotal(final);
        } else {
            let final = Math.round(total * 100) / 100;
            setTotal(final);
        }
    };

    const handledangerous = (e) => {
        setDangerous(parseFloat(e));
        const total = packages.reduce((a, b) => a + b.total, 0) + oversize + parseFloat(e) + custom + pickup + packaging + declaration + delivery + price + handling + insurance;
        if (brands?.customerType === "partner" || brands?.customerType === "admin") {
            const subTotal = packages.reduce((a, b) => a + b.total, 0) + oversize + parseFloat(e) + custom + pickup + packaging + declaration + delivery + price + handling + insurance;
            const total = subTotal - discountedAmount;
            let final = Math.round(total * 100) / 100;
            let final1 = Math.round(subTotal * 100) / 100;
            setSubTotal(final1);
            setTotal(final);
        } else {
            let final = Math.round(total * 100) / 100;
            setTotal(final);
        }
    };

    const handlecustom = (e) => {
        setCustom(parseFloat(e));
        const total = packages.reduce((a, b) => a + b.total, 0) + oversize + dangerous + parseFloat(e) + pickup + packaging + declaration + delivery + price + handling + insurance;
        if (brands?.customerType === "partner" || brands?.customerType === "admin") {
            const subTotal = packages.reduce((a, b) => a + b.total, 0) + oversize + dangerous + parseFloat(e) + pickup + packaging + declaration + delivery + price + handling + insurance;
            const total = subTotal - discountedAmount;
            let final = Math.round(total * 100) / 100;
            let final1 = Math.round(subTotal * 100) / 100;
            setSubTotal(final1);
            setTotal(final);
        } else {
            let final = Math.round(total * 100) / 100;
            setTotal(final);
        }
    };

    const handleLoyalty = (percentage) => {
        setLoyalty(parseFloat(percentage));
        const total = packages.reduce((a, b) => a + b.total, 0) + oversize + dangerous + custom + pickup + packaging + declaration + delivery + price + handling + insurance;
        const newTotal = total - percentage;
        let final = Math.round(newTotal * 100) / 100;
        setTotal(final);
    };

    const handlePickup = (e) => {
        setPickup(parseFloat(e));
        const total = packages.reduce((a, b) => a + b.total, 0) + oversize + dangerous + custom + parseFloat(e) + packaging + declaration + delivery + price + handling + insurance;
        if (brands?.customerType === "partner" || brands?.customerType === "admin") {
            const subTotal = packages.reduce((a, b) => a + b.total, 0) + oversize + dangerous + custom + parseFloat(e) + packaging + declaration + delivery + price + handling + insurance;
            const total = subTotal - discountedAmount;
            let final = Math.round(total * 100) / 100;
            let final1 = Math.round(subTotal * 100) / 100;
            setSubTotal(final1);
            setTotal(final);
        } else {
            let final = Math.round(total * 100) / 100;
            setTotal(final);
        }
    };

    const handlePackaging = (e) => {
        setPackaging(parseFloat(e));
        const total = packages.reduce((a, b) => a + b.total, 0) + oversize + dangerous + custom + parseFloat(e) + pickup + declaration + delivery + price + handling + insurance;
        if (brands?.customerType === "partner" || brands?.customerType === "admin") {
            const subTotal = packages.reduce((a, b) => a + b.total, 0) + oversize + dangerous + custom + parseFloat(e) + pickup + declaration + delivery + price + handling + insurance;
            const total = subTotal - discountedAmount;
            let final = Math.round(total * 100) / 100;
            let final1 = Math.round(subTotal * 100) / 100;
            setSubTotal(final1);
            setTotal(final);
        } else {
            let final = Math.round(total * 100) / 100;
            setTotal(final);
        }
    };

    const handleDelivery = (e) => {
        setDelivery(parseFloat(e));
        const total = packages.reduce((a, b) => a + b.total, 0) + oversize + dangerous + custom + parseFloat(e) + pickup + packaging + declaration + price + handling + insurance;
        if (brands?.customerType === "partner" || brands?.customerType === "admin") {
            const subTotal = packages.reduce((a, b) => a + b.total, 0) + oversize + dangerous + custom + parseFloat(e) + pickup + packaging + declaration + price + handling + insurance;
            const total = subTotal - discountedAmount;
            let final = Math.round(total * 100) / 100;
            let final1 = Math.round(subTotal * 100) / 100;
            setSubTotal(final1);
            setTotal(final);
        } else {
            let final = Math.round(total * 100) / 100;
            setTotal(final);
        }
    };

    const handleprice = (e) => {
        setPrice(parseFloat(e));
        const total = packages.reduce((a, b) => a + b.total, 0) + oversize + dangerous + custom + parseFloat(e) + pickup + packaging + declaration + delivery + handling + insurance;
        if (brands?.customerType === "partner" || brands?.customerType === "admin") {
            const subTotal = packages.reduce((a, b) => a + b.total, 0) + oversize + dangerous + custom + parseFloat(e) + pickup + packaging + declaration + delivery + handling + insurance;
            const total = subTotal - discountedAmount;
            let final = Math.round(total * 100) / 100;
            let final1 = Math.round(subTotal * 100) / 100;
            setSubTotal(final1);
            setTotal(final);
        } else {
            let final = Math.round(total * 100) / 100;
            setTotal(final);
        }
    };

    const handleDeclaration = (e) => {
        setDeclaration(parseFloat(e));
        if (e) {
            const total = packages.reduce((a, b) => a + b.total, 0) + oversize + dangerous + custom + parseFloat(e) + pickup + packaging + delivery + price + handling + insurance;
            if (brands?.customerType === "partner" || brands?.customerType === "admin") {
                const subTotal = packages.reduce((a, b) => a + b.total, 0) + oversize + dangerous + custom + parseFloat(e) + pickup + packaging + delivery + price + handling + insurance;

                const total = subTotal - discountedAmount;

                let final = Math.round(total * 100) / 100;
                let final1 = Math.round(subTotal * 100) / 100;
                setSubTotal(final1);
                setTotal(final);
            } else {
                let final = Math.round(total * 100) / 100;
                setTotal(final);
            }
        }
    };

    const handleMonthly = (e) => {
        setMonthly(parseFloat(e));
        const total = parseFloat(e) + website;
        let final = Math.round(total * 100) / 100;
        setTotal(final);
    };

    const handleWebsite = (e) => {
        setWebsite(parseFloat(e));
        const total = monthly + parseFloat(e);
        let final = Math.round(total * 100) / 100;
        setTotal(final);
    };

    const handleHandling = (e) => {
        setHandling(parseFloat(e));
        const total = packages.reduce((a, b) => a + b.total, 0) + oversize + dangerous + custom + pickup + packaging + declaration + delivery + price + parseFloat(e) + insurance;
        if (brands?.customerType === "partner" || brands?.customerType === "admin") {
            const subTotal = packages.reduce((a, b) => a + b.total, 0) + oversize + dangerous + custom + pickup + packaging + declaration + delivery + price + parseFloat(e) + insurance;
            const total = subTotal - discountedAmount;
            let final = Math.round(total * 100) / 100;
            let final1 = Math.round(subTotal * 100) / 100;
            setSubTotal(final1);
            setTotal(final);
        } else {
            let final = Math.round(total * 100) / 100;
            setTotal(final);
        }
    };

    const handleInsurance = (e) => {
        setInsurance(parseFloat(e));
        const total = packages.reduce((a, b) => a + b.total, 0) + oversize + dangerous + custom + pickup + packaging + declaration + delivery + price + handling + parseFloat(e);
        if (brands?.customerType === "partner" || brands?.customerType === "admin") {
            const subTotal = packages.reduce((a, b) => a + b.total, 0) + oversize + dangerous + custom + pickup + packaging + declaration + delivery + price + handling + parseFloat(e);
            const total = subTotal - discountedAmount;
            let final = Math.round(total * 100) / 100;
            let final1 = Math.round(subTotal * 100) / 100;
            setSubTotal(final1);
            setTotal(final);
        } else {
            let final = Math.round(total * 100) / 100;
            setTotal(final);
        }
    };

    const handleEdit = async () => {
        const invoice = brands;
        invoice.packages = packages;
        invoice.oversizeFee = oversize;
        invoice.dangerousItemFee = dangerous;
        invoice.customDuties = custom;
        invoice.invoiceAmount = total;
        invoice.loyaltyDiscount = loyalty;
        invoice.pickupFee = pickup;
        invoice.packagingFee = packaging;
        invoice.declarationFee = declaration;
        invoice.notes = notes;
        invoice.TotalAmount = SubTotal;
        invoice.discountedAmount = discountedAmount;
        invoice.MonthlyFee = monthly;
        invoice.WebsiteFee = website;
        invoice.itemsPrice = price;
        invoice.deliveryFee = delivery;
        invoice.handling = handling;
        invoice.insurance = insurance;
        const res = await handlePutRequest(invoice, "/updateInvoice");
        if (res?.success) {
            toast.success("invoice edited");
            window.location.reload();
        }
    };

    const handleMarkedReviewed = async () => {
        const data = {
            id: brands?._id,
            reviewStatus: "reviewed",
        };
        const res = await handlePutRequest(data, "/changeReviewStatus");
        if (res?.success) {
            toast.success("invoice marked as reviewed");
            window.location.reload();
        }
    };

    const handlePdf = () => {
        if (brands?.paymentStatus === "paid") {
            generatePDF(targetRef, {
                filename: `Receipt(${brands?.invoiceNo}).pdf`,
                page: {
                    format: "A3",
                    margin: {
                        top: 10,
                        right: 30,
                        bottom: 10,
                        left: 30,
                    },
                },
            });
        } else {
            setShow(false);
            setNotPaid(true);
        }
    };

    useEffect(() => {
        if (show === false && notpaid === true) {
            generatePDF(targetRef, {
                filename: "Invoice.pdf",
                page: {
                    format: "A3",
                    margin: {
                        top: 10,
                        right: 30,
                        bottom: 10,
                        left: 30,
                    },
                },
            });
            setShow(true);
            setNotPaid(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);

    const [showDialog, setShowDialog] = useState(false);
    const [showAdditionalDialog, setShowAdditionalDialog] = useState(false);
    const [showPurchaseEdit, setShowPurchaseEdit] = useState(false);
    const [showVoidDialog, setShowVoidDialog] = useState(false);
    const [voidReason, setVoidReason] = useState("");
    const [showCreditDialog, setShowCreditDialog] = useState(false);
    const [creditDialogKey, setCreditDialogKey] = useState(0);

    const onHideTyreBrandsDialog = () => {
        setShowDialog(false);
    };

    const onAdditionalInvoiceCreated = () => {
        setShowAdditionalDialog(false);
        toast.success("Additional invoice created");
        window.location.reload();
    };

    const onCreditGranted = () => {
        setShowCreditDialog(false);
        toast.success("Credit added to account");
        window.location.reload();
    };

    const onsuccess = () => {
        onHideTyreBrandsDialog();
        toast.success("Payment Made.");
        window.location.reload();
    };

    const handlePayment = () => {
        localStorage.setItem("invoiceId", brands?._id);
        localStorage.setItem("PaymentUser", "admin");
        history.push(`/payment`);
    };

    const [showSoftStop, setShowSoftStop] = useState(false);
    const [showSoftStop1, setShowSoftStop1] = useState(false);
    const [showSoftStop3, setShowSoftStop3] = useState(false);

    const openEdit = () => {
        setShowSoftStop(true);
    };

    const onHideSoftStop = () => {
        setShowSoftStop(false);
    };

    const onSuccessSoftStop = async () => {
        handleEdit();
    };

    const openPayment = () => {
        setShowSoftStop1(true);
    };

    const onHideSoftStop1 = () => {
        setShowSoftStop1(false);
    };

    const onSuccessSoftStop1 = async () => {
        handlePayment();
    };

    const openMarkedReviewed = () => {
        setShowSoftStop3(true);
    };

    const onHideSoftStop3 = () => {
        setShowSoftStop3(false);
    };

    const onSuccessSoftStop3 = async () => {
        handleMarkedReviewed();
    };

    // An additional invoice's entire content is its own additionalCharges
    // list (rendered separately below) - the flat fields below are only a
    // report-compatibility mirror of those same amounts, so showing both
    // here would double up every charge under two different labels. It also
    // never represents real shipped weight, so none of the package/weight
    // rendering applies to it either.
    const isAdditional = brands?.invoiceCategory === "additional";

    // A purchase invoice is goods bought for the client - it has its own items
    // list (rendered separately) and no shipping weight, fees or add-ons, so
    // everything shipping-specific is hidden the same way it is for additional
    // invoices. It is edited through its own dialog, not the add-on side panel.
    const isPurchase = brands?.invoiceCategory === "purchase";
    const hideShipping = isAdditional || isPurchase;
    const purchaseLocked = brands?.paymentStatus === "paid" || brands?.paidAmount > 0;

    const onPurchaseSaved = () => {
        setShowPurchaseEdit(false);
        window.location.reload();
    };

    const handleVoidPurchase = async () => {
        if (!voidReason.trim()) {
            toast.warn("A reason is required to void an invoice");
            return;
        }
        const res = await voidPurchaseInvoice(dispatch, brands._id, voidReason.trim());
        if (res?.success) {
            setShowVoidDialog(false);
            toast.success("Purchase invoice voided");
            history.push("/invoices");
        }
    };

    // One entry per aggregate add-on fee. Each maps 1:1 to the same handler
    // that existed before this refactor - only where the input lives (side
    // panel instead of inline in the table) changed.
    const feeRows =
        brands?.invoiceType !== "Monthly" && !hideShipping
            ? [
                  { key: "price", label: "Cost of Goods", value: price, onChange: handleprice },
                  { key: "oversize", label: brands?.type === "sea" ? "Handling" : "Oversize Fee", value: oversize, onChange: handleoverSize },
                  { key: "packaging", label: "Packaging", value: packaging, onChange: handlePackaging, isSelect: true },
                  { key: "pickup", label: "Pickup", value: pickup, onChange: handlePickup },
                  { key: "delivery", label: "Delivery", value: delivery, onChange: handleDelivery },
                  { key: "handling", label: "Handling", value: handling, onChange: handleHandling },
                  { key: "insurance", label: "Insurance", value: insurance, onChange: handleInsurance },
                  { key: "declaration", label: brands?.type === "sea" ? "Pre-Clearance" : "Declaration Fee", value: declaration, onChange: handleDeclaration },
                  { key: "custom", label: "Custom Duties", value: custom, onChange: handlecustom },
                  { key: "dangerous", label: "Dangerous Item Fee", value: dangerous, onChange: handledangerous },
              ]
            : [];

    // Loyalty discount only applies to plain clients (not partner/admin
    // accounts), same gating as the original handleLoyalityDiscount().
    const showLoyaltyField = brands?.invoiceType !== "Monthly" && !hideShipping && brands?.customerType !== "partner" && brands?.customerType !== "admin";

    const hasAnyAddOn = feeRows.some((row) => row.value !== 0) || (showLoyaltyField && loyalty !== 0);

    const getStatusMeta = (inv) => (inv?.paymentStatus === "paid" ? { label: "Paid", cls: styles.paid } : inv?.paidAmount > 0 ? { label: "Partially Paid", cls: styles.partial } : { label: "Pending", cls: styles.pending });

    const statusMeta = getStatusMeta(brands);

    // Shared between the desktop side panel and the mobile bottom sheet -
    // same fields, same handlers, just rendered inside two different
    // containers depending on viewport.
    const renderEditFields = () => (
        <>
            {feeRows.map((row) => (
                <div className={styles.editField} key={row.key}>
                    <label>{row.label}</label>
                    {row.isSelect ? (
                        <div className={styles.editInputRow}>
                            <select value={row.value} onChange={(e) => row.onChange(e.target.value)}>
                                <option value={0}>$0</option>
                                <option value={20}>$20</option>
                            </select>
                        </div>
                    ) : (
                        <div className={styles.editInputRow}>
                            <span>$</span>
                            <input type="number" value={row.value} onChange={(e) => row.onChange(e.target.value)} />
                        </div>
                    )}
                </div>
            ))}

            {showLoyaltyField && (
                <div className={styles.editField}>
                    <label>Loyalty Discount</label>
                    <div className={styles.editInputRow}>
                        <span>$</span>
                        <input type="number" value={loyalty} onChange={(e) => handleLoyalty(e.target.value)} />
                    </div>
                </div>
            )}

            {brands?.invoiceType === "Monthly" && !hideShipping && (
                <div className={styles.editField}>
                    <label>Monthly Fee</label>
                    <div className={styles.editInputRow}>
                        <span>$</span>
                        <input type="number" value={monthly} onChange={(e) => handleMonthly(e.target.value)} />
                    </div>
                </div>
            )}
            {brands?.invoiceType === "Monthly" && !hideShipping && (
                <div className={styles.editField}>
                    <label>Website Usage Fee</label>
                    <div className={styles.editInputRow}>
                        <span>$</span>
                        <input type="number" value={website} onChange={(e) => handleWebsite(e.target.value)} />
                    </div>
                </div>
            )}

            <div className={styles.editField}>
                <label>Notes</label>
                <textarea className={styles.editTextarea} value={notes} onChange={(e) => setNotes(e.target.value)} />
            </div>
        </>
    );

    return (
        <>
            <Dialog visible={showDialog} header="Pay Invoice" style={{ width: "650px" }} onHide={() => setShowDialog(false)}>
                <PaymentModel onHideTyreBrandsDialog={onHideTyreBrandsDialog} onsuccess={onsuccess} />
            </Dialog>
            <Dialog visible={showSoftStop} style={{ width: "650px" }} onHide={() => setShowSoftStop(false)}>
                <SoftStops onHideSoftStop={onHideSoftStop} onSuccessSoftStop={onSuccessSoftStop} message="Are you sure you want to edit this invoice?"></SoftStops>
            </Dialog>
            <Dialog visible={showSoftStop1} style={{ width: "650px" }} onHide={() => setShowSoftStop1(false)}>
                <SoftStops onHideSoftStop={onHideSoftStop1} onSuccessSoftStop={onSuccessSoftStop1} message="Are you sure you want to pay for this invoice?"></SoftStops>
            </Dialog>
            <Dialog visible={showSoftStop3} style={{ width: "650px" }} onHide={() => setShowSoftStop3(false)}>
                <SoftStops onHideSoftStop={onHideSoftStop3} onSuccessSoftStop={onSuccessSoftStop3} message="Are you sure you want to mark this invoice as reviewed?"></SoftStops>
            </Dialog>
            <Dialog visible={showAdditionalDialog} header="Create Additional Invoice" style={{ width: "700px" }} onHide={() => setShowAdditionalDialog(false)}>
                <CreateAdditionalInvoiceDialog parentInvoiceId={brands?._id} onHideDialog={() => setShowAdditionalDialog(false)} onsuccess={onAdditionalInvoiceCreated} />
            </Dialog>
            <Dialog visible={showPurchaseEdit} header="Edit Purchase Invoice" style={{ width: "720px", maxWidth: "95vw" }} contentStyle={{ overflowX: "hidden" }} onHide={() => setShowPurchaseEdit(false)}>
                {isPurchase && <PurchaseInvoiceDialog invoice={brands} onHideDialog={() => setShowPurchaseEdit(false)} onsuccess={onPurchaseSaved} />}
            </Dialog>
            <Dialog visible={showVoidDialog} header="Void Purchase Invoice" style={{ width: "500px" }} onHide={() => setShowVoidDialog(false)}>
                <p>This removes the invoice from every list. A reason is required.</p>
                <InputTextarea value={voidReason} onChange={(e) => setVoidReason(e.target.value)} rows={3} style={{ width: "100%" }} placeholder="Reason for voiding" />
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem", marginTop: "1rem" }}>
                    <Button label="Cancel" className="p-button-text" onClick={() => setShowVoidDialog(false)} />
                    <Button label="Void Invoice" icon="pi pi-ban" className="p-button-danger" onClick={handleVoidPurchase} disabled={!voidReason.trim()} />
                </div>
            </Dialog>
            <Dialog visible={showCreditDialog} header="Reverse Payment to Credit" style={{ width: "550px" }} onHide={() => setShowCreditDialog(false)}>
                <GrantCreditDialog
                    key={creditDialogKey}
                    clientId={brands?.clientId?._id}
                    clientName={brands?.clientName || `${brands?.clientId?.firstName || ""} ${brands?.clientId?.lastName || ""}`.trim()}
                    invoice={{ _id: brands?._id, invoiceId: brands?.invoiceId, invoiceNo: brands?.invoiceNo, paidAmount: brands?.paidAmount }}
                    onHideDialog={() => setShowCreditDialog(false)}
                    onsuccess={onCreditGranted}
                />
            </Dialog>

            <div className={styles.pageContainer}>
                <div className={styles.toolbar}>
                    <div className={styles.toolbarLeft}>
                        <span className={styles.invoiceNo}>Invoice #{brands?.invoiceId}</span>
                        <span className={`${styles.statusBadge} ${statusMeta.cls}`}>{statusMeta.label}</span>
                        {brands?.supersededBy && <span className={styles.creditedBadge}>Credited Back</span>}
                        {isClerk && <span className={styles.clerkNote}>Clerk mode: add-ons and notes are editable - item weights are locked</span>}
                    </div>
                    <div className={styles.toolbarActions}>
                        <Tooltip title="Download Invoice as PDF" position="bottom" trigger="mouseenter" arrow={true}>
                            <Button icon="pi pi-file-pdf" label="PDF" className={styles.actionBtn} onClick={handlePdf} />
                        </Tooltip>
                        {!paid && !isPurchase && (
                            <Tooltip title="Save changes to this invoice" position="bottom" trigger="mouseenter" arrow={true}>
                                <Button icon="pi pi-save" label="Save Changes" className={styles.actionBtn} onClick={openEdit} disabled={viewOnly} />
                            </Tooltip>
                        )}
                        {!paid && (
                            <Tooltip title="Pay Invoice" position="bottom" trigger="mouseenter" arrow={true}>
                                <Button icon="pi pi-wallet" label="Pay" className={styles.actionBtn} onClick={openPayment} />
                            </Tooltip>
                        )}
                        {!paid && (
                            <Tooltip title="Mark as reviewed" position="bottom" trigger="mouseenter" arrow={true}>
                                <Button icon="pi pi-search-plus" label="Mark Reviewed" className={styles.actionBtn} onClick={openMarkedReviewed} disabled={viewOnly} />
                            </Tooltip>
                        )}
                        {role === "admin" && isPurchase && (
                            <>
                                <Tooltip title={purchaseLocked ? "A payment is recorded - this invoice can no longer be edited" : "Edit items, merchant and linked packages"} position="bottom" trigger="mouseenter" arrow={true}>
                                    <Button icon="pi pi-pencil" label="Edit" className={styles.actionBtn} onClick={() => setShowPurchaseEdit(true)} disabled={viewOnly || purchaseLocked} />
                                </Tooltip>
                                <Tooltip title={purchaseLocked ? "A payment is recorded - reverse it to credit first" : "Void this purchase invoice"} position="bottom" trigger="mouseenter" arrow={true}>
                                    <Button icon="pi pi-ban" label="Void" className={styles.actionBtn} onClick={() => { setVoidReason(""); setShowVoidDialog(true); }} disabled={viewOnly || purchaseLocked} />
                                </Tooltip>
                            </>
                        )}
                        {role === "admin" && brands?.invoiceCategory !== "additional" && !isPurchase && !brands?.supersededBy && (
                            <Tooltip title="Bill a new charge on this invoice separately" position="bottom" trigger="mouseenter" arrow={true}>
                                <Button icon="pi pi-plus-circle" label="Add Charge" className={`${styles.actionBtn} ${styles.actionBtnPrimary}`} onClick={() => setShowAdditionalDialog(true)} disabled={viewOnly} />
                            </Tooltip>
                        )}
                        {role === "admin" && brands?.paidAmount > 0 && !brands?.supersededBy && (
                            <Tooltip title="Move this invoice's paid amount back to account credit" position="bottom" trigger="mouseenter" arrow={true}>
                                <Button icon="pi pi-undo" label="Reverse to Credit" className={styles.actionBtn} onClick={() => { setCreditDialogKey((k) => k + 1); setShowCreditDialog(true); }} disabled={viewOnly} />
                            </Tooltip>
                        )}
                    </div>
                </div>

                {brands?.invoiceCategory === "additional" && brands?.parentInvoiceDoc && (
                    <div className={styles.parentInvoiceBanner}>
                        <span>
                            Additional charge linked to Invoice #{brands.parentInvoiceDoc.invoiceId}
                        </span>
                        <Button label="View Parent Invoice" className="p-button-text" onClick={() => history.push(`/invoice?id=${brands.parentInvoiceDoc._id}`)} />
                    </div>
                )}

                {brands?.supersededBy && brands?.supersededByDoc && (
                    <div className={styles.parentInvoiceBanner}>
                        <span>
                            This charge now lives on Invoice #{brands.supersededByDoc.invoiceId}
                            {brands.supersededByDoc.clientName && brands.supersededByDoc.clientName !== brands.clientName ? ` (${brands.supersededByDoc.clientName})` : ""}
                        </span>
                        <Button label="View New Invoice" className="p-button-text" onClick={() => history.push(`/invoice?id=${brands.supersededByDoc._id}`)} />
                    </div>
                )}

                {brands?.supersedes && brands?.supersedesDoc && (
                    <div className={styles.parentInvoiceBanner}>
                        <span>
                            This invoice replaces Invoice #{brands.supersedesDoc.invoiceId}
                        </span>
                        <Button label="View Original Invoice" className="p-button-text" onClick={() => history.push(`/invoice?id=${brands.supersedesDoc._id}`)} />
                    </div>
                )}

                {brands?.invoiceCategory !== "additional" && brands?.additionalInvoices?.length > 0 && (
                    <div className={styles.additionalInvoicesCard}>
                        <p className={styles.additionalInvoicesTitle}>Additional Invoices</p>
                        {brands.additionalInvoices.map((child) => {
                            const childStatus = getStatusMeta(child);
                            return (
                                <div className={styles.additionalInvoiceRow} key={child._id} onClick={() => history.push(`/invoice?id=${child._id}`)}>
                                    <div className={styles.additionalInvoiceMain}>
                                        <span className={styles.additionalInvoiceId}>#{child.invoiceId}</span>
                                        {child.descriptions && <span className={styles.additionalInvoiceDesc}>{child.descriptions}</span>}
                                    </div>
                                    <span className={styles.additionalInvoiceAmount}>{formatMoney(child.invoiceAmount)}</span>
                                    <span className={`${styles.statusBadge} ${childStatus.cls}`}>{childStatus.label}</span>
                                </div>
                            );
                        })}
                    </div>
                )}

                <div className={show ? styles.layoutEditing : styles.layout}>
                    <div className={styles.documentColumn}>
                        <div className={styles.documentOuter} ref={targetRef}>
                            {paid && <Water />}
                            <div className={`${styles.paper} ${brands?.supersededBy ? styles.supersededDocument : ""}`}>
                                <div className={styles.docHeader}>
                                    <img src={"https://res.cloudinary.com/dwxqg9so3/image/upload/w_500,q_auto:best,f_auto,dpr_2.0/v1758208458/4wd_logo_white_duzzog.png"} className={styles.logo} alt="logo" />
                                    <div className={styles.infoGrid}>
                                        <div className={styles.infoBlock}>
                                            <h4>Client Info</h4>
                                            <span>{brands?.clientName}</span>
                                            <span>{brands?.email}</span>
                                            <span>{brands?.phone}</span>
                                        </div>
                                        <div className={styles.infoBlock}>
                                            <h4>Shipping Address</h4>
                                            <p>1470 Lee Wagener Blvd, 101</p>
                                            <p>Fort Lauderdale</p>
                                            <p>FL 33315</p>
                                        </div>
                                    </div>
                                </div>

                                <div className={styles.docTitleRow}>
                                    <h2 className={styles.docTitle}>{paid ? "Receipt" : "Invoice"}</h2>
                                </div>

                                <div className={styles.metaList}>
                                    <div className={styles.metaRow}>
                                        <span className={styles.metaLabel}>Order Date</span>
                                        <span className={styles.metaValue}>{brands?.date}</span>
                                    </div>
                                    <div className={styles.metaRow}>
                                        <span className={styles.metaLabel}>Payment Method</span>
                                        <span className={styles.metaValue}>Card {brands?.datePaid ? `at ${brands?.datePaid}` : null}</span>
                                    </div>
                                    {!hideShipping && (
                                        <div className={styles.metaRow}>
                                            <span className={styles.metaLabel}>Total {brands?.type === "sea" ? "Size" : "Weight"}</span>
                                            <span className={styles.metaValue}>
                                                {brands?.weight} {brands?.type === "sea" ? "Cu ft" : "Lbs"}
                                            </span>
                                        </div>
                                    )}
                                    {isPurchase && brands?.purchase?.merchant && (
                                        <div className={styles.metaRow}>
                                            <span className={styles.metaLabel}>Merchant</span>
                                            <span className={styles.metaValue}>{brands.purchase.merchant}</span>
                                        </div>
                                    )}
                                    {isPurchase && brands?.purchase?.orderNumber && (
                                        <div className={styles.metaRow}>
                                            <span className={styles.metaLabel}>Order Number</span>
                                            <span className={styles.metaValue}>{brands.purchase.orderNumber}</span>
                                        </div>
                                    )}
                                    {isPurchase && (
                                        <div className={styles.metaRow}>
                                            <span className={styles.metaLabel}>Linked Waybills</span>
                                            <span className={styles.metaValue}>{brands?.Waybills || "Not linked to a package yet"}</span>
                                        </div>
                                    )}
                                    <div className={styles.metaRow}>
                                        <span className={styles.metaLabel}>Contents</span>
                                        <span className={styles.metaValue}>{brands?.descriptions}</span>
                                    </div>
                                </div>

                                <table className={styles.table}>
                                    <thead>
                                        <tr>
                                            <th>{isPurchase ? "Item" : hideShipping ? "Description" : "Product"}</th>
                                            <th>{isPurchase ? "Qty" : hideShipping ? "" : brands?.type === "sea" ? "Size" : "Weight"}</th>
                                            <th>{isPurchase ? "Unit Price" : hideShipping ? "" : "Price"}</th>
                                            <th>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isAdditional &&
                                            brands?.additionalCharges?.map((charge, index) => (
                                                <tr className={styles.row} key={index}>
                                                    <td>{charge.label}</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>${Number(charge.amount).toFixed(2)}</td>
                                                </tr>
                                            ))}

                                        {isPurchase &&
                                            brands?.purchase?.items?.map((item, index) => (
                                                <tr className={styles.row} key={index}>
                                                    <td>
                                                        {item.url ? (
                                                            <a href={item.url} target="_blank" rel="noopener noreferrer">
                                                                {item.description}
                                                            </a>
                                                        ) : (
                                                            item.description
                                                        )}
                                                    </td>
                                                    <td>{item.quantity}</td>
                                                    <td>${Number(item.unitPrice).toFixed(2)}</td>
                                                    <td>${(Number(item.quantity) * Number(item.unitPrice)).toFixed(2)}</td>
                                                </tr>
                                            ))}

                                        {isPurchase && Number(brands?.purchase?.shipping) > 0 && (
                                            <tr className={styles.row}>
                                                <td>Merchant Shipping</td>
                                                <td></td>
                                                <td></td>
                                                <td>${Number(brands.purchase.shipping).toFixed(2)}</td>
                                            </tr>
                                        )}
                                        {isPurchase && Number(brands?.purchase?.tax) > 0 && (
                                            <tr className={styles.row}>
                                                <td>Tax</td>
                                                <td></td>
                                                <td></td>
                                                <td>${Number(brands.purchase.tax).toFixed(2)}</td>
                                            </tr>
                                        )}

                                        {brands?.invoiceType !== "Monthly" &&
                                            !hideShipping &&
                                            packages?.map((item, index) => {
                                                let temp;
                                                let prev = packages[index - 1]?.product;
                                                if (brands?.customerType === "client") {
                                                    if (brands?.size === "sea") {
                                                        temp = "Total Size of Cargo";
                                                    } else {
                                                        if (item?.product === prev) {
                                                            temp = "Additional Pounds";
                                                        } else {
                                                            temp = "1st Pound of Cargo";
                                                        }
                                                    }
                                                } else {
                                                    if (brands?.type === "sea") {
                                                        temp = "Total Size of Cargo";
                                                    } else {
                                                        temp = "Total Pounds of Cargo";
                                                    }
                                                }
                                                return (
                                                    <tr className={styles.row} key={item?._id || index}>
                                                        <td>{temp}</td>
                                                        {show && (
                                                            <td>
                                                                <input disabled={isClerk} type="number" className={styles.weightInput} value={item?.weight} onChange={(e) => handlePackages("weight", e.target.value, index)} /> {item?.type === "sea" ? "cu" : "lb"}
                                                            </td>
                                                        )}
                                                        {!show && (
                                                            <td>
                                                                {item?.weight} {item?.type === "sea" ? "cu" : "lb"}
                                                            </td>
                                                        )}
                                                        <td>${item?.price}</td>
                                                        <td>${(item?.total).toFixed(2)}</td>
                                                    </tr>
                                                );
                                            })}

                                        {hasAnyAddOn && (
                                            <tr className={styles.row}>
                                                <td className={styles.addOnLabelCell} style={{ fontWeight: 600 }}>
                                                    Add-ons
                                                </td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                        )}

                                        {feeRows.map(
                                            (row) =>
                                                row.value !== 0 && (
                                                    <tr className={styles.row} key={row.key}>
                                                        <td className={styles.addOnLabelCell}>{row.label}</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>${row.value}</td>
                                                    </tr>
                                                ),
                                        )}

                                        {showLoyaltyField && loyalty !== 0 && (
                                            <tr className={styles.row}>
                                                <td className={styles.addOnLabelCell}>Loyalty Discount</td>
                                                <td></td>
                                                <td></td>
                                                <td>${loyalty}</td>
                                            </tr>
                                        )}

                                        {brands?.invoiceType === "Monthly" && !hideShipping && (
                                            <tr className={styles.row}>
                                                <td>Monthly Fee</td>
                                                <td></td>
                                                <td></td>
                                                <td>${monthly}</td>
                                            </tr>
                                        )}
                                        {brands?.invoiceType === "Monthly" && !hideShipping && (
                                            <tr className={styles.row}>
                                                <td>Website usage Fee</td>
                                                <td></td>
                                                <td></td>
                                                <td>${website}</td>
                                            </tr>
                                        )}

                                        <tr className={`${styles.row} ${styles.subtotalRow}`}>
                                            <td>Sub-Total</td>
                                            <td></td>
                                            <td></td>
                                            <td>${brands?.customerType === "partner" || brands?.customerType === "admin" ? SubTotal : total}</td>
                                        </tr>
                                        {brands?.customerType === "partner" ||
                                            (brands?.customerType === "admin" && (
                                                <tr className={styles.row}>
                                                    <td>{brands?.customerType === "partner" ? "Credit Discount" : "Admin Discount"}</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>- ${(brands?.discountedAmount).toFixed(2)}</td>
                                                </tr>
                                            ))}

                                        <tr className={styles.row}>
                                            <td>Tax</td>
                                            <td></td>
                                            <td></td>
                                            <td>$0</td>
                                        </tr>

                                        {brands?.paymentStatus === "pending" && !(brands?.paidAmount > 0) && (
                                            <tr className={`${styles.row} ${styles.totalRow}`}>
                                                <td>Total</td>
                                                <td></td>
                                                <td></td>
                                                <td>${total}</td>
                                            </tr>
                                        )}
                                        {brands?.paymentStatus === "pending" && brands?.paidAmount > 0 && (
                                            <>
                                                <tr className={styles.row}>
                                                    <td>Paid Amount</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>${(brands?.paidAmount).toFixed(2)}</td>
                                                </tr>
                                                <tr className={`${styles.row} ${styles.totalRow}`}>
                                                    <td>Remaining Amount</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>${(brands?.invoiceAmount).toFixed(2)}</td>
                                                </tr>
                                            </>
                                        )}
                                        {brands?.paymentStatus === "paid" && (
                                            <tr className={`${styles.row} ${styles.totalRow}`}>
                                                <td>Total</td>
                                                <td></td>
                                                <td></td>
                                                <td>${(brands?.paidAmount).toFixed(2)}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                <div className={styles.notesSection}>
                                    <p className={styles.notesTitle}>Customer Note</p>
                                    <p className={styles.notesIntro}>THANK YOU for choosing Move4wd as your shipping partner! Please see your order updates below.</p>
                                    <ul className={styles.notesList}>
                                        <li>Status: Preparing Package for Shipment</li>
                                        <li>Shipment: {brands?.shipmentNumber}</li>
                                        <li>Package: {brands?.Waybills}</li>
                                        {notes && <li>Notes: {notes}</li>}
                                    </ul>
                                    <p className={styles.zipNote}> PLEASE USE 00000 for the ZIP Code when using a Jamaican Debit/Credit Card) to make payment.</p>

                                    <img
                                        src="https://res.cloudinary.com/dwxqg9so3/image/upload/v1696375833/WhatsApp_Image_2023-09-25_at_03.12.56_463150e6_ua2zka.jpg"
                                        className={styles.whatsappBanner}
                                        onClick={() => handlePayment()}
                                        alt="Pay via WhatsApp"
                                    />
                                    <p className={styles.footerText}>
                                        <strong>Move4wd</strong> is a registered corporation in Florida, United States
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {show && !isPurchase && (
                        <div className={styles.editPanel}>
                            <p className={styles.editPanelTitle}>
                                <i className="pi pi-sliders-h" /> Edit Add-ons
                            </p>
                            {renderEditFields()}
                        </div>
                    )}
                </div>

                {show && !isPurchase && (
                    <button type="button" className={styles.editFab} aria-label="Edit Add-ons" onClick={() => setMobileEditOpen(true)}>
                        <i className="pi pi-sliders-h" />
                    </button>
                )}

                <Sidebar visible={mobileEditOpen} position="bottom" onHide={() => setMobileEditOpen(false)} className={styles.editSheet}>
                    <div className={styles.mobileEditSheet}>
                        <p className={styles.mobileEditTitle}>
                            <i className="pi pi-sliders-h" /> Edit Add-ons
                        </p>
                        {renderEditFields()}
                    </div>
                </Sidebar>
            </div>
        </>
    );
}

export default Invoice;
